import { Button, Container, IconButton, Typography } from "@mui/material";
import { GrHostMaintenance } from "react-icons/gr";
import { useNavigate } from 'react-router-dom';

export const MantenimientoPage:React.FC<{}> = () => {
    let history = useNavigate();

    const handleGoBack = () => {
      history(-1);
    };

    return(
        <Container maxWidth="sm" sx={{mt:8, p:1}}>
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <Typography variant="h4" component="h1">
            En Mantenimiento
            </Typography>
            <IconButton aria-label="delete" color="info" sx={{ fontSize: '360px'}} >
            <GrHostMaintenance />
            </IconButton>
            <Typography variant="body1">¡Lo siento, esta sección se encuentra en mantenimiento!</Typography>
            <Typography variant="body1">Lamentamos las molestias y agradecemos tu comprensión.</Typography>
            <Typography variant="body1">¡Gracias!</Typography>            
            <br />
            <Button variant="contained" aria-label="delete" color="primary" onClick={handleGoBack}>
            VOLVER
            </Button>         
          </div>
        </Container>
    );
}